module.exports = __webpack_public_path__ + "img/homepage-content-image-mitsu.6b421eae.jpg";